var SiteContext = function(){};

SiteContext.CONTEXT_P4 = 'web';
SiteContext.CONTEXT_P1 = 'web-p1';
SiteContext.CONTEXT_PB = 'web-pb';

SiteContext.isPraha4 = function(){
	return $('html').data('context') === SiteContext.CONTEXT_P4;
};

SiteContext.isPraha1 = function(){
	return $('html').data('context') === SiteContext.CONTEXT_P1;
};

SiteContext.isPribram = function(){
   return $('html').data('context') === SiteContext.CONTEXT_PB;
};
